import jwt_token from "jwt-decode";
import { useEffect, useState } from "react";
import T from "../../common/traducao.js";
import { GetOperacoes, getToken } from "../../config/localstorageConfig/localstorage.js";
import SelectControl from "./control-selectcontrol.jsx";

const OperacaoVendaControl = (props) => {

    const [operacoes, setOperacoes] = useState([]);
    const [permitirAlterarOperacaoVenda, setPermitirAlterarOperacaoVenda] = useState(false);
    const constantes = T();

    useEffect(() => {
        const _operacoes = GetOperacoes();
        const newoperacoes = _operacoes && _operacoes.map((item, i) => {
            return { Id: item.Id, Descricao: item.Descricao, Valor: item.Id, TipoOperacao: item.TipoOperacao }
        });

        setOperacoes(newoperacoes);

        const token = jwt_token(getToken());
        setPermitirAlterarOperacaoVenda(!token?.PermitirAlterarOperacaoVenda);
    }, [])

    return (
        <SelectControl
            {...props}
            name={"OrcamentoVenda.IdOperacaoVenda"}
            placeholder={constantes.OperacaoVenda}
            itens={operacoes}
            disabled={permitirAlterarOperacaoVenda || props?.disabled}
        />
    )
}

export default OperacaoVendaControl;